export const NEWS_LOADING = "NEWS_LOADING";
export const NEWS_ERROR = "NEWS_ERROR";

export const NEWS_GET_LIST = "NEWS_GET_LIST";
export const NEWS_GET_FILTERS = "NEWS_GET_FILTERS";
export const NEWS_GET_SINGLE = "NEWS_GET_SINGLE";
export const NEWS_CREATE = "NEWS_CREATE";
export const NEWS_GET_TYPES = "NEWS_GET_TYPES";



// WEBPACK FOOTER //
// ./src/actions/news/constants.js